import { PaymentDetailsDTO, StoreDTO } from 'models'
import { Constraints } from '@touche-lts/panel-ui/dist'

export const initialStoreDto: StoreDTO = {
  address: null,
  createdDate: null,
  currency: null,
  email: '',
  id: null,
  images: null,
  info: '',
  name: '',
  paymentDetails: {
    businessId: '',
    createdDate: null,
    id: null,
    password: '',
    status: null,
    token: '',
    username: ''
  },
  phoneNumber: null,
  rating: null,
  reviews: null,
  reviewsCnt: null,
  shippings: null,
  status: null,
  tags: null,
  users: [],
  websiteUrl: '',
  youtubeURL: null,
  squareCrop: undefined,
  backgroundCrop: undefined,
  shopifyAccessToken: null,
  shopifyStoreUrl: '',
  shopifySecretKey: '',
  shopifyStorefrontToken: null,
  clientId: null,
  accessTokenCreate: null,
  geminiKey: ''
}

const paymentDetailsConstraints: Constraints<PaymentDetailsDTO> = {
  businessId: {
    presence: true,
    length: { minimum: 1 }
  },
  password: {
    presence: true,
    length: { minimum: 6 }
  },
  token: {
    presence: true,
    length: { minimum: 2 }
  },
  username: {
    presence: true,
    length: { minimum: 2 }
  }
}

const parseSublevelConstraints = (args: {
  prefix: string
  constraints: object
}): object => {
  const result = {}
  for (const key in args.constraints) {
    result[`${args.prefix}.${key}`] = args.constraints[key]
  }
  return result
}

export const createStoreConstraints: Constraints<StoreDTO> = {
  email: {
    presence: true,
    email: true
  },
  info: {
    presence: true,
    length: { minimum: 2 }
  },
  name: {
    presence: true,
    length: { minimum: 2 }
  },
  ...parseSublevelConstraints({
    prefix: 'paymentDetails',
    constraints: paymentDetailsConstraints
  }),
  websiteUrl: {
    presence: true,
    url: true
  },
  // shopifyStoreUrl: {
  //   // format: {
  //   //   pattern: /^https:\/\/[a-zA-Z0-9-]+\.myshopify\.com$/,
  //   //   message: '^Shopify Store URL must contain ".myshopify.com"',
  //   // },
  //   url: true
  // }
}
